import { createApp } from 'vue';
import i18n from '../i18n';
import App from './App.vue';

(() => {
    const container = document.getElementById('vue-best-fare-students');
    if (container) {
        const configData = container.getAttribute('data-config');
        let dataTree = null;
        if (configData) {
            try {
                dataTree = JSON.parse(configData);
            } catch (e) {
                console.error('Failed to parse config data:', e); // eslint-disable-line no-console
            }
        }
        const app = createApp(App, { dataTree });

        app.use(i18n);
        app.mount(container);
    }
})();
